import { render, staticRenderFns } from "./uploadfile.vue?vue&type=template&id=b79e9076&scoped=true&"
import script from "./uploadfile.vue?vue&type=script&lang=js&"
export * from "./uploadfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79e9076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b79e9076')) {
      api.createRecord('b79e9076', component.options)
    } else {
      api.reload('b79e9076', component.options)
    }
    module.hot.accept("./uploadfile.vue?vue&type=template&id=b79e9076&scoped=true&", function () {
      api.rerender('b79e9076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/uploadfile/uploadfile.vue"
export default component.exports